module.exports = __webpack_public_path__ + "img/mC-big-V5.7cbb9813.png";